module.exports = __webpack_public_path__ + "img/3_2.dd7b452a.jpg";